import React, { useState, useEffect } from 'react';
import { ControlLabel } from 'react-bootstrap';
import Request from 'superagent';
import Image from './image';
import { MainHead, Logo, Unsupported, Error, Supported, Middle } from './style/configure.style';
import './css/channel.css';
import 'react-datepicker/dist/react-datepicker.css';

function normalizeToken(raw) {
    const t = raw.toUpperCase();
    if (t.length === 6 && !t.includes('-')) return t.slice(0, 3) + '-' + t.slice(3);
    return t;
}

export default function ResolveToken({ token: propToken, userProfile, screenSelected }) {
    const [token, setToken] = useState('');
    const [validationError, setValidationError] = useState(null);
    const [openDisabled, setOpenDisabled] = useState(true);

    useEffect(() => {
        if (propToken.length > 0) {
            const normalized = normalizeToken(propToken);
            setToken(normalized);
            getToken(normalized);
        }
    }, []);

    function handleChange(e) {
        let val = e.target.value.toUpperCase();
        if (val.length === 6 && !val.includes('-')) {
            val = val.slice(0, 3) + '-' + val.slice(3);
        } else if (val.length === 4 && val[3] !== '-') {
            val = val.slice(0, 3) + '-' + val[3];
        }
        setToken(val);
        setOpenDisabled(val.length !== 7);
        setValidationError(null);
    }

    function handleKeyDown(e) {
        if (e.key === 'Enter' && !openDisabled) {
            e.preventDefault();
            e.stopPropagation();
            getToken(token);
        }
    }

    function getToken(tokenValue) {
        const url = userProfile[0].serverIP + '/php/ob_clock.php?argument1=getToken&argument2=' + JSON.stringify({ token: tokenValue });
        Request.get(url).then((response) => {
            if (response.body[0].Result === 'OK') {
                if (response.body[0].rowCount === 1) {
                    const d = response.body[0].data[0];
                    screenSelected({
                        screenWidth: d.screen_width,
                        orientation: d.orientation,
                        eventScreenID: d.event_screen_id,
                        screenName: d.screen_name,
                        eventID: d.event_id,
                        timeMaster: d.time_master === 't',
                        deviceType: d.device_type,
                        clientPublicIP: response.body[0].remoteIP,
                        siteID: d.site_id,
                        siteName: d.site_name,
                        customerID: d.customer_id,
                        customerName: d.customer_name,
                    });
                } else {
                    setValidationError('error');
                    setOpenDisabled(false);
                }
            } else {
                alert('Error in getToken: ' + response.body[0].Result);
            }
        });
    }

    const isIE = !!document.documentMode;
    const isEdge = !isIE && !!window.StyleMedia;
    const unsupportedBrowser = isIE || isEdge;

    return (
        <div>
            <Logo>
                <a href="http://www.radio.management/" target="_blank">
                    <Image src={window.location.href + 'staticImages/orquestraDio.svg'} width="100%" height="100%" mode='fit' />
                </a>
            </Logo>
            <MainHead>ORQUESTRADIO</MainHead>
            <Middle>
                <div style={{
                    display: 'inline-block',
                    border: '1px solid #ffffff33',
                    borderRadius: '8px',
                    padding: '28px 36px 24px',
                    backgroundColor: '#2a2a2a',
                    boxShadow: '0 4px 24px rgba(0,0,0,0.5)',
                }}>
                    <Supported display={unsupportedBrowser ? 'none' : 'block'}>
                        <ControlLabel style={{ fontSize: '20px', fontWeight: 500, color: '#ffffff66' }}>Token</ControlLabel>
                        <input type="text"
                            style={{ width: '110px', borderStyle: 'none', boxShadow: 'none', paddingRight: 0, paddingLeft: '10px', position: 'relative', top: '-2px', color: 'white', backgroundColor: '#2a2a2a' }}
                            className="form-control input-lg"
                            autoFocus={true}
                            name="tokenPrefix"
                            value={token}
                            maxLength={7}
                            onKeyDown={handleKeyDown}
                            onChange={handleChange}
                            placeholder="___-___" />
                        <br />
                        <div style={{ color: '#ffffff44', fontSize: '13px', marginTop: '6px' }}>press Enter to open</div>
                        <Error display={validationError === 'error' ? 'block' : 'none'}>
                            Dashboard token does not exist or has expired
                        </Error>
                    </Supported>
                    <Unsupported display={unsupportedBrowser ? 'block' : 'none'}>
                        Due to current limitations in how Microsoft support web standards,
                        Internet Explorer and Edge browsers will not work with Orquestradio.
                        <br />
                        Mozilla Firefox, Google Chrome and Apple Safari browsers do support current
                        web standards and have been successfully tested.
                    </Unsupported>
                </div>
            </Middle>
        </div>
    );
}
